var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"timeline-entry note"},[_c('div',{staticClass:"timeline-entry-inner"},[_c('div',{staticClass:"timeline-icon"}),_vm._v(" "),_c('div',{staticClass:"timeline-content"},[_c('div',{staticClass:"note-header"}),_vm._v(" "),_c('div',{staticClass:"note-body"},[_c('skeleton-loading-container')],1)])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4491f3c","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/notes/skeleton_note.vue
// module id = null
// module chunks = 